// @ts-nocheck
import { NextObserver } from 'rxjs';
import { Job } from '../util/job';
import { UploadResponse } from './response';

export class UploadJob extends Job {
  public constructor(
    public path: string,
    public args: any[],
    public observer: NextObserver<UploadResponse>,
  ) {
    super(path, args);
  }
}
